/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/OCREngine.yaml

import { ScanbotOcrEngineImpl } from './impl';
import type { PerformOcrResult } from './types/base/OcrEngineResult';
import type { ImageInput, OcrConfiguration } from './types/base/customTypes';

/**
 * Entry point for all OCR engine features.
 */
export const ScanbotOcrEngine = {
  /**
   * Performs OCR on the provided images with the specified configuration.
   * @param {ImageInput[]} params.images - The list of images to be used for OCR processing.
   * @param {OcrConfiguration} params.configuration - The configuration for OCR processing.
   * @returns {Promise<PerformOcrResult>} - The result of the OCR processing.
   */
  async recognizeOnImages(params: {
    images: ImageInput[];
    configuration?: OcrConfiguration;
  }): Promise<PerformOcrResult> {
    return ScanbotOcrEngineImpl.recognizeOnImages(params);
  },
  /**
   * Performs OCR on the provided document with the specified configuration.
   * @param {string} params.documentUuid - The Uuid of the document to be used for OCR processing.
   * @param {OcrConfiguration} params.configuration - The configuration for OCR processing.
   * @returns {Promise<PerformOcrResult>} - The result of the OCR processing.
   */
  async recognizeOnDocument(params: {
    documentUuid: string;
    configuration?: OcrConfiguration;
  }): Promise<PerformOcrResult> {
    return ScanbotOcrEngineImpl.recognizeOnDocument(params);
  },
};
